import { render } from "./EditMessageDialog.vue?vue&type=template&id=e92f01f0"
import script from "./EditMessageDialog.vue?vue&type=script&lang=js"
export * from "./EditMessageDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__